import { render, staticRenderFns } from "./ModalSm.vue?vue&type=template&id=18755551&scoped=true&"
import script from "./ModalSm.vue?vue&type=script&lang=js&"
export * from "./ModalSm.vue?vue&type=script&lang=js&"
import style0 from "./ModalSm.vue?vue&type=style&index=0&id=18755551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18755551",
  null
  
)

export default component.exports